import { createAsyncThunk } from '@reduxjs/toolkit';
import { BannerItemForEdit, WebBlockKey } from '../../../types/Models/MainPage/MainPageModel';
import { createRequest } from '../../../helpers/api/createRequest';
import * as mainPageApi from '../../../api/mainPage';
import { getWebBanners } from './getWebBanners';
import { Thunk } from '../../../helpers/redux/Thunk';
import { addNotification } from '../../notifications/addNotification';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { TypesIcon } from '../../../types/TypesIcon';

export const EDIT_BANNER_ITEMS_WEB = 'mainPage/editBannerItemsWeb';

const onSuccess = (): Thunk => async dispatch => {
    dispatch(getWebBanners());

    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Изменения сохранены',
            description: '',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));
};

export const editBannerItemsWeb = createAsyncThunk(
    EDIT_BANNER_ITEMS_WEB,
    createRequest({
        type: EDIT_BANNER_ITEMS_WEB,
        loader: async (data: {key: WebBlockKey, newData: BannerItemForEdit[]}) => mainPageApi.editBannerItems(data),
        onSuccess,
    }),
);
